import stringByKeyByLocale from "content/l10n/l10n-complete"

class L10n {
  constructor(options) {
    this._locale = options.locale
  }

  // this is for using handlebars style template within l10n strings
  // templateMap should be a object containing key value pairs like:
  // `{name:'Arun'}`, then instances of `{{name}}` in the string will
  // be replaced with `Arun`. We use a regexp so that every instance
  // of the key will be replaced, not just the first instance.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  replaceAllKeysWithValues(templateString, templateMap) {
    Object.keys(templateMap).forEach(
      (key) => (templateString = templateString.replace(new RegExp(`{{${key}}}`, "g"), templateMap[key]))
    )
    return templateString
  }

  localize(key, templateMap) {
    // Support being called as a tag on a string template for
    // syntactic convenience, e.g.: localize`test.HelloWorld`
    // (instead of localize('test.helloWorld')).
    //
    // N.B. We don't actually use any of the tagging features
    // in string keys; this is purely to avoid the need for
    // parenthesis marks around the argument list. This is
    // especially powerful when combined with a short alias
    // for the localize function, e.g.:
    //
    // const l = l10n.getBoundLocalize();
    // ...
    // <div id="blah">${l`test.blahString`}</div>
    //
    // If you need to use string interpolation, you have to use parentheses, e.g.:
    //
    //   l(`client.content.${articleId}.title`)
    //
    if (Array.isArray(key)) {
      key = key[0]
    }

    let outputString = stringByKeyByLocale[this._locale][key] ?? key

    if (templateMap) {
      outputString = this.replaceAllKeysWithValues(outputString, templateMap)
    }

    return outputString
  }

  getBoundLocalize() {
    const self = this
    return function () {
      return self.localize.apply(self, arguments)
    }
  }
}

export default L10n
